<template>
  <div class="container">
    <div class="content">
      <label>
        <span class="title">アプリ会員ID</span>
        <span class="userid">{{ this.formData.userId }}</span>
        <span
          v-show="this.formValidationErrors.userId"
          :style="{
            'background-image': 'url(' + validationErrorBGImageSrc + ')'
          }"
        >
          {{ this.formValidationErrors.userId }}
        </span>
      </label>

      <label>
        <span class="title">来店した店舗</span>
        <input type="text" v-model="formData.shopName" placeholder="" />
        <span
          v-show="this.formValidationErrors.shopName"
          :style="{
            'background-image': 'url(' + validationErrorBGImageSrc + ')'
          }"
        >
          {{ this.formValidationErrors.shopName }}
        </span>
      </label>

      <label>
        <span class="title">来店した日時</span>
        <span class="caption">おおよその時刻で結構です。</span>
        <input
          type="text"
          v-model="formData.datetime"
          placeholder="例) 7/15の午後3時ごろ"
        />
        <span
          v-show="this.formValidationErrors.datetime"
          :style="{
            'background-image': 'url(' + validationErrorBGImageSrc + ')'
          }"
        >
          {{ this.formValidationErrors.datetime }}
        </span>
      </label>

      <label>
        <span class="title">お問い合わせ内容</span>&nbsp;<span class="require"
          >※必須</span
        >
        <span class="caption"
          >「来店してもスタンプがもらえない」「QRコードが案内されない」など。</span
        >
        <span
          v-show="this.formValidationErrors.content"
          :style="{
            'background-image': 'url(' + validationErrorBGImageSrc + ')'
          }"
          class="error"
        >
          {{ this.formValidationErrors.content }}
        </span>
        <textarea v-model="formData.content" placeholder="" />
      </label>

      <p class="caption">
        <span style="color: red">※店舗に関するお問い合わせは下記にお願いします。</span><br /><br />
        【メールでのお問い合わせ】<br />
        香の川製麺公式ホームページ内ご意見ご要望問い合わせフォームよりお願いします。<br /><br />
        ※土・日・祝日にいただいたお問い合わせは翌営業日の受付となります。<br />
        ※support@friendly-co.comよりご返信させていただきますので、メール受信制限等を設定されている場合は、上記のアドレスを受信していただけるよう設定の変更をお願いいたします。
      </p>
      <button class="execute" @click="this.createMail">メール送信</button>
      <p>
        ※ボタンを押した後、メールが立ち上がりますので送信ボタンを押してください。
      </p>
    </div>
  </div>
</template>

<script>
import { FactoryTrack } from '../constant/firebase.js'
import { mapActions } from 'vuex'
import DateFormatter from '../utils/DateFormatter'
import '@/styles/color.css'

export default {
  name: 'inquiry',
  data: function() {
    return {
      title: 'お問い合わせ',
      backButtonBGImageSrc: require('@/assets/img/buttons/back@3x.png'),
      validationErrorBGImageSrc: require('@/assets/img/data-inherit/error.png'),
      formData: {
        userId: '',
        shopName: '',
        datetime: '',
        content: ''
      },
      formValidationErrors: {
        userId: '',
        shopName: '',
        datetime: '',
        content: ''
      }
    }
  },
  created() {
    document.title = 'お問合わせ'

    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.formData.userId = json.user_id
        window.receivedToken = null
      }
      // クーポン一覧と同じなので一旦apiTypeを3に設定する
      this.actionRequestToken({ apiType: '3', acc_time: accTime })
    } catch (e) {
      console.log(e)
    }
  },
  mounted() {},
  methods: {
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Native', ['actionRequestToken']),
    ...mapActions('Analytics', ['trackEvent']),
    validUserId(userId) {
      const re = /^[a-z0-9]{16}$/
      return re.test(userId)
    },
    validRequire(password) {
      const re = /.+/
      return re.test(password)
    },
    historyBack() {
      this.$router.go(-1)
    },
    createMail() {
      if (!this.validRequire(this.formData.content)) {
        this.formValidationErrors.content = 'お問い合わせ内容を入力してください'
      }
      if (!this.validRequire(this.formData.content)) {
        return
      }

      this.trackEvent(FactoryTrack.createSendMail('お問い合わせ'))
      const address = 'support@friendly-co.com'
      const subject = 'アプリに関するお問い合わせ'
      let body = `
■アプリ会員ID： \n\
${this.formData.userId}\n\
\n\
■来店した店舗名： \n\
${this.formData.shopName || '記入なし'}\n\
\n\
■来店した日時： \n\
${this.formData.datetime || '記入なし'}\n\
\n\
■お問い合わせ内容：\n\
${this.formData.content.replace(/\n/g, '\n')} \n\
\n\
※土・日・祝日にいただいたお問合せは翌営業日の受付となります。\n\
※support@friendly-co.comよりご返信させて頂きますので、メール受信制限等を設定されている場合は、左記のアドレスを受信して頂けるよう設定の変更をお願い致します。\n\
`

      const encodedBody = encodeURIComponent(body);

      location.href =
        'mailto:' + address + '?subject=' + subject + '&body=' + encodedBody
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  font-family: HiraKakuPro-W6;
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  border-bottom: 1px #dddddd solid;
  background-color: #ffffff;

  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;

  a {
    position: absolute;
    left: 0;

    button.back {
      height: 44px;
      width: 44px;
      background: none;
      border: none;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 8px 14px;
    }
  }
}

.container {
  position: relative;
  min-height: 100%;
  background-color: #ffffff;

  .content {
    padding: 16px;

    p {
      text-align: left;
      color: #333333;
      font-size: 13px;
      margin-bottom: 30px;
      &.caption {
        text-align: left;
        margin: 16px 0;
        font-size: 10px;
        color: rgb(102, 102, 102);
      }
    }
    span.userid {
      font-size: 16px;
    }
  }
}

label {
  display: block;
  text-align: left;
  color: var(--accent-color);
  margin-bottom: 20px;

  span {
    &.title {
      font-size: 13px;
      display: inline-block;

      font-weight: bold;
    }
    &.require {
      color: #e03535;
      display: inline-block;
    }
    display: block;

    font-size: 11px;
    padding-top: 5px;
    background-repeat: no-repeat;
    background-size: 12px;
    background-position: left 6px;
    &.error {
      padding-left: 15px;
      color: #e03535;
    }
  }
}

input[type='text'],
textarea {
  font-size: 14px;
  width: 100%;
  padding: 12px;
  letter-spacing: 1px;
  font-family: HiraKakuPro-W6;
  background-color: var(--background-color);
  appearance: none;
  border: 1px solid var(--accent-color);
  border-radius: 4px;
  font-weight: bold;
  outline: none;
  margin-top: 5px;
}
input[type='text'] {
  height: 41px;
}
textarea {
  height: 200px;
}

button.execute {
  width: 100%;
  background: var(--accent-color);
  border-radius: 7px;
  border: none;
  font-size: 15px;
  font-weight: bold;
  color: #ffffff;
  padding: 13px 2px;
  margin-bottom: 20px;
}

button.cancel {
  color: #333333;
  font-size: 14px;
  background: none;
  border: none;
  border-bottom: 1px solid #333333;
}
</style>
